import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-feather";

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f4f7fc;
  border: 1px solid #c7d2e8;
  color: #334155;
  font-size: 1rem;
  font-weight: 800;
  cursor: pointer;
  padding: 9px 13px;
  border-radius: 6px;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  margin-bottom: 20px;

  &:hover {
    background-color: #f0f9ff;
    border-color: #22B8D1;
    color: #0369a1;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

const BackButton = ({ to = "/" }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(to);
  };

  return (
    <StyledButton type="button" onClick={handleBackClick}>
      <ArrowLeft />
      Voltar
    </StyledButton>
  );
};

export default BackButton;
